export const egyptStates = [
    { id: "ALX", name: "Alexandria" },
    { id: "ASN", name: "Aswan" },
    { id: "AST", name: "Assiut" },
    { id: "BH", name: "Beheira" },
    { id: "BNS", name: "Beni Suef" },
    { id: "C", name: "Cairo" },
    { id: "DK", name: "Dakahlia" },
    { id: "DT", name: "Damietta" },
    { id: "FYM", name: "Fayoum" },
    { id: "GH", name: "Gharbia" },
    { id: "GZ", name: "Giza" },
    { id: "IS", name: "Ismailia" },
    { id: "KFS", name: "Kafr El Sheikh" },
    { id: "MT", name: "Matrouh" },
    { id: "MN", name: "Minya" },
    { id: "MNF", name: "Monufia" },
    { id: "WAD", name: "New Valley" },
    { id: "NS", name: "North Sinai" },
    { id: "PS", name: "Port Said" },
    { id: "KB", name: "Qalyubia" },
    { id: "KN", name: "Qena" },
    { id: "RS", name: "Red Sea" },
    { id: "SHR", name: "Sharqia" },
    { id: "SHG", name: "Sohag" },
    { id: "SNS", name: "South Sinai" },
    { id: "SUZ", name: "Suez" },
    { id: "LX", name: "Luxor" }
]

export const latoStates = [
    { id: "ABM", name: "Abim" },
    { id: "ADJ", name: "Adjumani" },
    { id: "AGG", name: "Agago" },
    { id: "ALB", name: "Alebtong" },
    { id: "AMO", name: "Amolatar" },
    { id: "AMU", name: "Amudat" },
    { id: "AMR", name: "Amuria" },
    { id: "AMW", name: "Amuru" },
    { id: "APC", name: "Apac" },
    { id: "ARU", name: "Arua" },
    { id: "ARC", name: "Arua City" },
    { id: "BDK", name: "Budaka" },
    { id: "BDD", name: "Bududa" },
    { id: "BGR", name: "Bugiri" },
    { id: "BGW", name: "Bugweri" },
    { id: "BHJ", name: "Buhweju" },
    { id: "BKW", name: "Buikwe" },
    { id: "BKD", name: "Bukedea" },
    { id: "BKM", name: "Bukomansimbi" },
    { id: "BKO", name: "Bukwo" },
    { id: "BML", name: "Bulambuli" },
    { id: "BLS", name: "Buliisa" },
    { id: "BDG", name: "Bundibugyo" },
    { id: "BNY", name: "Bunyangabu" },
    { id: "BSH", name: "Bushenyi" },
    { id: "BSA", name: "Busia" },
    { id: "BTJ", name: "Butaleja" },
    { id: "BTA", name: "Butambala" },
    { id: "BTE", name: "Butebo" },
    { id: "BVM", name: "Buvuma" },
    { id: "BYD", name: "Buyende" },
    { id: "DOK", name: "Dokolo" },
    { id: "FPC", name: "Fort Portal City" },
    { id: "GMB", name: "Gomba" },
    { id: "GLU", name: "Gulu" },
    { id: "GLC", name: "Gulu City" },
    { id: "HMA", name: "Hoima" },
    { id: "HMC", name: "Hoima City" },
    { id: "IBD", name: "Ibanda" },
    { id: "IGG", name: "Iganga" },
    { id: "ISR", name: "Isingiro" },
    { id: "JNJ", name: "Jinja" },
    { id: "JNC", name: "Jinja City" },
    { id: "KBG", name: "Kaabong" },
    { id: "KBL", name: "Kabale" },
    { id: "KBR", name: "Kabarale" },
    { id: "KBM", name: "Kaberamaido" },
    { id: "KGD", name: "Kagadi" },
    { id: "KKM", name: "Kakumiro" },
    { id: "KLK", name: "Kalaki" },
    { id: "KLG", name: "Kalangala" },
    { id: "KLR", name: "Kaliro" },
    { id: "KLU", name: "Kalungu" },
    { id: "KMP", name: "Kampala" },
    { id: "KML", name: "Kamuli" },
    { id: "KMW", name: "Kamwenge" },
    { id: "KNU", name: "Kanungu" },
    { id: "KPC", name: "Kapchorwa" },
    { id: "KPB", name: "Kapelebyong" },
    { id: "KRG", name: "Karenga" },
    { id: "KSS", name: "Kasese" },
    { id: "KSN", name: "Kassanda" },
    { id: "KTK", name: "Katakwi" },
    { id: "KYG", name: "Kayunga" },
    { id: "KZO", name: "Kazo" },
    { id: "KBA", name: "Kibaale" },
    { id: "KBO", name: "Kiboga" },
    { id: "KBK", name: "Kibuku" },
    { id: "KKB", name: "Kikuube" },
    { id: "KRH", name: "Kiruhura" },
    { id: "KRY", name: "Kiryandongo" },
    { id: "KSR", name: "Kisoro" },
    { id: "KTG", name: "Kitagwenda" },
    { id: "KTM", name: "Kitgum" },
    { id: "KOB", name: "Koboko" },
    { id: "KLE", name: "Kole" },
    { id: "KTD", name: "Kotido" },
    { id: "KUM", name: "Kumi" },
    { id: "KWN", name: "Kwania" },
    { id: "KWE", name: "Kween" },
    { id: "KYK", name: "Kyankwanzi" },
    { id: "KYE", name: "Kyegegwa" },
    { id: "KYJ", name: "Kyenjojo" },
    { id: "KYT", name: "Kyotera" },
    { id: "LMW", name: "Lamwo" },
    { id: "LRA", name: "Lira" },
    { id: "LRC", name: "Lira City" },
    { id: "LUK", name: "Luuka" },
    { id: "LWR", name: "Luweero" },
    { id: "LWG", name: "Lwengo" },
    { id: "LYT", name: "Lyantonde" },
    { id: "MDO", name: "Madi-Okollo" },
    { id: "MNW", name: "Manafwa" },
    { id: "MRA", name: "Maracha" },
    { id: "MSK", name: "Masaka" },
    { id: "MSC", name: "Masaka City" },
    { id: "MSD", name: "Masindi" },
    { id: "MYG", name: "Mayuge" },
    { id: "MBL", name: "Mbale" },
    { id: "MBCity", name: "Mbale City" },
    { id: "MBR", name: "Mbarara" },
    { id: "MBRCity", name: "Mbarara City" },
    { id: "MTO", name: "Mitooma" },
    { id: "MTY", name: "Mityana" },
    { id: "MRT", name: "Moroto" },
    { id: "MYO", name: "Moyo" },
    { id: "MPI", name: "Mpigi" },
    { id: "MBD", name: "Mubende" },
    { id: "MKN", name: "Mukono" },
    { id: "NBL", name: "Nabilatuk" },
    { id: "NKP", name: "Nakapiripirit" },
    { id: "NKS", name: "Nakaseke" },
    { id: "NKG", name: "Nakasongola" },
    { id: "NMY", name: "Namayingo" },
    { id: "NMS", name: "Namisindwa" },
    { id: "NMT", name: "Namutumba" },
    { id: "NPK", name: "Napak" },
    { id: "NEB", name: "Nebbi" },
    { id: "NGR", name: "Ngora" },
    { id: "NTR", name: "Ntoroko" },
    { id: "NTG", name: "Ntungamo" },
    { id: "NWY", name: "Nwoya" },
    { id: "OBG", name: "Obongi" },
    { id: "OMR", name: "Omoro" },
    { id: "OTK", name: "Otuke" },
    { id: "OYM", name: "Oyam" },
    { id: "PDR", name: "Pader" },
    { id: "PKW", name: "Pakwach" },
    { id: "PLS", name: "Pallisa" },
    { id: "RAK", name: "Rakai" },
    { id: "RBD", name: "Rubanda" },
    { id: "RBZ", name: "Rubirizi" },
    { id: "RKG", name: "Rukiga" },
    { id: "RKN", name: "Rukungiri" },
    { id: "RWP", name: "Rwampara" },
    { id: "SRR", name: "Serere" },
    { id: "SHM", name: "Sheema" },
    { id: "SRK", name: "Sironko" },
    { id: "SRT", name: "Soroti" },
    { id: "SRC", name: "Soroti City" },
    { id: "SSB", name: "Ssembabule" },
    { id: "TRG", name: "Terego" },
    { id: "TRR", name: "Tororo" },
    { id: "WKS", name: "Wakiso" },
    { id: "YMB", name: "Yumbe" },
    { id: "ZMB", name: "Zombo" }
]

export const getMatchingEgyptStates = (stateList) => {
    return egyptStates.filter(state => stateList.includes(state.name));
};

export const getMatchingLatoStates = (stateList) => {
    return latoStates.filter(state => stateList.includes(state.name));
};
  